'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _immutable = require('redux-form/immutable');

var _PresetAmountSelectorsComponent = require('./PresetAmountSelectorsComponent');

var _selectors = require('../../selectors');

var _constants = require('../../constants');

var _actions = require('../../actions');

var qdFormSelector = (0, _immutable.formValueSelector)(_constants.QD_RF_FORM_NAME);

/**
 * Maps the state to properties
 * @param {StateType} state The state map
 * @param {Object} props the container properties
 * @returns {Object} The properties to be passed to the Selection component
 */
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    amountValues: (0, _selectors.initDataSelector)(state, props).amountButtons || [],
    currentAmountValue: qdFormSelector(state, _constants.QD_RF_FIELD_AMOUNT),
    currencyCode: (0, _selectors.currencyCodeSelector)(state, props),
    hasPlayerSetAmount: (0, _selectors.playerAmountSelectionSelector)(state)
  };
};

var mapDispatchToProps = {
  change: _immutable.change,
  updateQuickDepositInitData: _actions.updateQuickDepositInitData,
  updatePlayerSetAmount: _actions.updatePlayerSetAmount
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_PresetAmountSelectorsComponent.PresetAmountSelectorsComponent);